@if (mission) {
  <table>
    <tr>
      <td><img src="assets/images/team.svg"/></td>
      <td>{{ 'MISSION.TEAM' | translate }}</td>
      <td><button (click)="navigateToTeam()" [ngClass]="getStatusClass(mission.teamstatus, false)">{{ mission.teamstatus | statusLabel | async }}</button></td>
      <td><img src="assets/images/shopping-cart.svg"/>{{ getTeamCount() }}</td>
    </tr>
    <tr>
      <td><img src="assets/images/truck.svg"/></td>
      <td>{{ 'MISSION.PRODUCT' | translate }}</td>
      <td><button (click)="navigateToProduct()" [ngClass]="getStatusClass(mission.productstatus, true)">{{ mission.productstatus | statusLabel | async }}</button></td>
      <td><img src="assets/images/shopping-cart.svg"/>{{ getProductCount() }}</td>
    </tr>
    <tr>
      <td><img src="assets/images/tools.svg"/></td>
      <td>{{ 'MISSION.MATERIAL' | translate }}</td>
      <td><button (click)="navigateToMaterial()" [ngClass]="getStatusClass(mission.materialstatus, true)">{{ mission.materialstatus | statusLabel | async }}</button></td>
      <td><img src="assets/images/shopping-cart.svg"/>{{ getMaterialCount() }}</td>
    </tr>
    <tr>
      <td><img src="assets/images/support.svg"/></td>
      <td>{{ 'MISSION.SUPPORT' | translate }}</td>
      <td><button (click)="navigateToSupport()" [ngClass]="getStatusClass(mission.supportstatus, false)">{{ mission.supportstatus | statusLabel | async }}</button></td>
      <td><img src="assets/images/shopping-cart.svg"/>{{ getSupportCount() }}</td>
    </tr>
    <tr>
      <td><img src="assets/images/customers.png"/></td>
      <td>{{ 'MISSION.PARTICIPANTS' | translate }}</td>
      <td><button (click)="navigateToParticipant()" [ngClass]="getParticipantsStatusClass()">{{ getParticipantsStatus() | statusLabel | async }}</button></td>
      <td><img src="assets/images/shopping-cart.svg"/>{{ getParticipantCount() }}</td>
    </tr>
  </table>
}